import { Label, Stack, IStyle } from "@fluentui/react";
import React from "react";

import { Badge, BadgeColor } from "../..";

export interface LabeledBadgeProps {
    label: string;
    color?: BadgeColor;
    value?: string | number;
    maxLength?: number;
    testId?: string;
    labelFontSize?: number | string;
    labelFontWeight?: string;
    labelStyle?: IStyle;
    badgeSize?: number;
}

export const LabeledBadge: React.FunctionComponent<LabeledBadgeProps> = (props: LabeledBadgeProps) => {
    const { color, label, value, testId, labelFontSize, labelFontWeight, labelStyle, badgeSize } = props;

    const stackStyles = {
        root: {
            marginBottom: 10,
            flexDirection: "column",
            gap: 4
        }
    };

    const mergedLabelStyle: IStyle = mergeIStyle(
        {
            fontSize: labelFontSize,
            fontWeight: labelFontWeight,
            padding: 0
        },
        labelStyle
    );

    return (
        <Stack data-testid={testId} styles={stackStyles}>
            <Label styles={{ root: mergedLabelStyle }}>{label}</Label>
            <Badge size={badgeSize} color={color} text={value ? value.toString() : "-"} />
        </Stack>
    );
};

const mergeIStyle = (base: IStyle, extra?: IStyle): IStyle => {
    if (extra && typeof extra === "object" && !Array.isArray(extra)) {
        return Object.assign({}, base, extra);
    }
    return base;
};
